import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/index/Home.vue'
import Index from './views/Index.vue'
import Login from './views/login/Login.vue'
import Cooling from './views/index/coolingSys.vue'

import {logout} from "./api/http";

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/', redirect: '/index',},
    {path: '/login', name: 'login', component: Login},
    {
      path: '/index', name: 'index', component: Index,
      redirect: 'index/home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home,
          meta: {
            requiredAuth: true,
          }
        }, {
          path: 'coolingSys',
          name: 'coolingSys',
          component: Cooling,
        }, {
          path: 'boilerSys',
          name: 'boilerSys',
          component: () => import('./views/index/boilerSys.vue')
        }, {
          path: 'userMan',
          name: 'userMan',
          component: () => import('./views/index/userMan.vue')
        }, {
          path: 'platformConfig',
          name: 'platformConfig',
          component: () => import('./views/index/platformConfig.vue')
        }, {
          path: 'weaElcMan',
          name: 'weaElcMan',
          component: () => import('./views/index/weaElcMan.vue')
        }, {
          path: 'KPI',
          name: 'KPI',
          component: () => import('./views/index/KPI.vue')
        }, {
          path: 'runningReport',
          name: 'runningReport',
          component: () => import('./views/index/runningReport.vue')
        }, {
          path: 'alarmInfo',
          name: 'alarmInfo',
          component: () => import('./views/index/alarmInfo.vue')
        }, {
          path: 'systemVav',
          name: 'systemVav',
          component: () => import('./views/index/systemVav.vue')
        }, {
          path: 'airSys',
          name: 'airSys',
          component: () => import('./views/index/airSys.vue')
        }, {
          path: 'equipInfo',
          name: 'equipInfo',
          component: () => import('./views/index/equipInfo.vue')
        }, {
          path: 'filterInfo',
          name: 'filterInfo',
          component: () => import('./views/index/filterInfo.vue')
        },{
          path: 'gshpSys',
          name: 'gshpSys',
          component: () => import('./views/index/gshpSys.vue')
        },
      ]
    },
  ]
});
router.beforeEach((to, from, next) => {
  if (to.meta.requiredAuth) {
    if ((localStorage.getItem('access_token') && localStorage.getItem('username')) || from.fullPath === '/login') {
      next();
    } else {
      logout();
    }
  } else {
    next();
  }
});

export default router;
